import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import cn from "classnames";
import OutsideClickHandler from "react-outside-click-handler";
import styles from "./User.module.sass";
import Icon from "../../Icon";
import { useUser } from "../../../context";
import brand_text from "../../../i11/brand";

import Messages from "../Messages";
const userEnum = {
	admin: "Super admin",
	brandAdmin: "Brand admin",
	brandOperator: "Marketplace operator",
};

const User = ({ className }) => {
	const [visible, setVisible] = useState(false);
	const {
		locale,
		logOut,
		brand,
		tokens: { group, username },
	} = useUser();

	const items =
		group === "admin" && !brand
			? [
					{
						menu: [
							{
								title: brand_text[locale].logout,
							},
						],
					},
			  ]
			: [
					{
						menu: [
							{
								title: brand_text[locale].profile,
								url: "/settings",
							},
						],
					},
					{
						menu: [
							{
								title: brand_text[locale].logout,
							},
						],
					},
			  ];
	return (
		<OutsideClickHandler onOutsideClick={() => setVisible(false)}>
			<div className={cn(styles.user, className, { [styles.active]: visible })}>
				<Messages className={styles.lang} />
				<div
					onClick={() => setVisible(!visible)}
					className={styles.headWrapper}
				>
					<div>
						<span>{username}</span>
						<span>{userEnum[group]}</span>
					</div>
					<button className={styles.head}>
						<Icon name="profile-circle" className={styles.myIcon} size="48" />
					</button>
				</div>
				<div className={styles.body}>
					{items.map((item, index) => (
						<div className={styles.menu} key={"elll_" + index}>
							{item.menu.map((x, index) =>
								x.url ? (
									x.isBlank ? (
										<a
											rel="noreferrer"
											className={cn(styles.item, { [styles.color]: x.color })}
											activeClassName={styles.active}
											href={x.url}
											target="_blank"
											onClick={() => setVisible(false)}
											key={"eeell_" + index}
										>
											{x.icon && <Icon name={x.icon} size="24" />}
											{x.title}
										</a>
									) : (
										<NavLink
											className={cn(styles.item, { [styles.color]: x.color })}
											activeClassName={styles.active}
											to={x.url}
											onClick={() => setVisible(false)}
											key={"eeell_" + index}
										>
											{x.icon && <Icon name={x.icon} size="24" />}
											{x.title}
										</NavLink>
									)
								) : (
									<button
										className={styles.item}
										onClick={() => {
											setVisible(false);
											logOut();
										}}
										key={"eelllll" + index}
									>
										{x.title}
									</button>
								)
							)}
						</div>
					))}
				</div>
			</div>
		</OutsideClickHandler>
	);
};

export default User;
